/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import axios from "axios";

require('./bootstrap');

window.Vue = require('vue').default;

import router from './router';
import App from './layouts/App.vue';

//Add Bootstrap Vue, Bootstrap Icons.
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue';

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

//Add Vue Editor.
import Vue2Editor from "vue2-editor";
Vue.use(Vue2Editor);

//Add VueMask.
import {VueMaskDirective} from "v-mask";
Vue.directive('mask', VueMaskDirective);

//Import our store used for Vuex.
import store from './store';

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => {
//     Vue.component(
//         files(key).default.name ?? key.split('/').pop().split('.')[0],
//         files(key).default
//     )
// });

Vue.component('logo', require('./components/Logo.vue').default);
Vue.component('logo-small', require('./components/LogoSmall').default);
Vue.component('logo-horizontal', require('./components/LogoHorizontal.vue').default);

Vue.component('auth-login-form', require('./components/AuthLoginForm.vue').default);
Vue.component('auth-logout-link', require('./components/AuthLogoutLink.vue').default);
Vue.component('auth-forgot-password-form', require('./components/AuthForgotPasswordForm.vue').default);
Vue.component('auth-reset-password-form', require('./components/AuthResetPasswordForm.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import {API} from "./api";
API.defaults.headers.common['Authorization'] = `Bearer ${store.state.auth.token}`;
Vue.prototype.$api = API;

// window.axios.defaults.headers.common['Authorization'] = `Bearer ${store.state.auth.token}`;

const app = new Vue({
    router,
    el: '#app',
    render: h => h(App),
    store,
    created() {
        //Check auth status if user was logged in.
        if (this.$store.state.auth.is_user_logged_in) {
            this.$store.dispatch('auth/checkAuth');
            //Do it every 30 seconds.
            let authCheckInterval = setInterval(() => {
                if (!this.$store.state.auth.is_user_logged_in) {
                    clearInterval(authCheckInterval);
                    return;
                }
                this.$store.dispatch('auth/checkAuth');
            }, 30000);
        }
    }
});
